import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';
import type { MembershipEntity } from '../entities/MembershipEntity.js';

interface Deps { membershipRepository: IMembershipRepository; }
export function createListMembershipsUseCase({ membershipRepository }: Deps) {
  return async function listMemberships(orgId: string, projectId?: string, roleId?: string, limit?: number, offset?: number, profileId?: string): Promise<{ data: MembershipEntity[]; total: number }> {
    return membershipRepository.listMemberships(orgId, projectId, roleId, limit, offset, profileId);
  };
}
